import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import Rocket from 'images/rocket.png';
import RocketEn from 'images/rocket-en.png';
import {isTranslate} from 'shared/lib/lang';

import {IFreeTariffFact} from '../../lib/freeTariffFacts';
import FreePlan from '../FreePlan/FreePlan';
import LivePreview from '../LivePreview/LivePreview';

import styles from './Hero.module.scss';

const ROCKET_WIDTH = 420;
const ROCKET_HEIGHT = 168;

interface IHeroProps {
    facts: IFreeTariffFact[],
}

const Hero: React.FC<IHeroProps> = ({facts}) => {
    const hasFreePlan = !isTranslate() && facts.length > 0;

    return (
        <div className={styles.hero}>
            <div className={styles.heroText}>
                {
                    hasFreePlan &&
                    <span className={styles.badge}>
                        <span className={styles.badgeDot}/>
                        {t`Бесплатный тариф навсегда`}
                    </span>
                }
                <h1 className={styles.title}>
                    <Trans id="home.plug.title" message="Узнавайте о сбоях раньше,"/>
                    <span className={styles.subtitle}>
                        <Trans id="home.plug.subtitle" message="чем их заметят клиенты!"/>
                        <span className={styles.iconRocket}>&#128640;</span>
                    </span>
                </h1>
                <p className={styles.lead}>
                    <Trans
                        id="home.plug.lead"
                        message="Overseer следит за сайтами, серверами, портами и доменами круглосуточно
                            и сообщает о проблеме в первые минуты — почтой, в Telegram или MAX."
                    />
                </p>
                {hasFreePlan && <FreePlan facts={facts}/>}
            </div>
            <div className={styles.stage}>
                <img
                    className={styles.rocket}
                    src={isTranslate() ? RocketEn : Rocket}
                    width={ROCKET_WIDTH}
                    height={ROCKET_HEIGHT}
                    alt=""
                />
                <LivePreview/>
            </div>
        </div>
    );
};

export default Hero;
